<template>
  <b-container fluid class="p-0">
    <b-row class="mb-3 justify-content-end align-items-center">
      <b-col v-if="$hasPermission([0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 13]) && kdsList.length > 1" class="mb-2 mb-lg-0" sm="12" md="3">
        <div>
          <b-input-group prepend="Display">
            <b-form-select v-model="Filter_KDS" :options="kdsList" @change="changeKds"></b-form-select>
          </b-input-group>
        </div>
      </b-col>
      <b-col sm="12" md="3">
        <div v-if="$hasPermission([0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11])">
          <b-input-group>
            <template v-slot:prepend>
              <b-btn style="cursor:default;" class="font-weight-bold">Server</b-btn>
            </template>
            <b-form-select @change="changeServer" v-model="ServerName" :options="servers"></b-form-select>
          </b-input-group>
        </div>
      </b-col>
      <b-col sm="12" md="4">
        <div class="my-2 my-md-0">
          <b-input-group size="lg">
            <template v-slot:append>
              <b-btn variant="warning" size="md" @click="searchInReport" :disabled="loadingBtn">
                <span v-if="!loadingBtn">Search</span>
                <font-awesome-icon v-else spin icon="circle-notch" class="align-middle" />
              </b-btn>
              <b-btn v-if="showResetBtn" variant="danger" size="md" @click="resetSearch" :disabled="loadingBtn">
                <span v-if="!loadingBtn">Reset</span>
                <font-awesome-icon v-else spin icon="circle-notch" class="align-middle" />
              </b-btn>
            </template>
            <b-form-input type="text" name="Search" v-model="Search" />
          </b-input-group>
        </div>
      </b-col>
    </b-row>
    <!--        <b-row class="my-2">-->
    <!--            <b-col>-->
    <!--                <b-btn variant="danger" to="/createOrder?from=orderHistory">-->
    <!--                    Create Tab-->
    <!--                </b-btn>-->
    <!--            </b-col>-->
    <!--        </b-row>-->
    <b-table
      ref="table"
      class="bg-white reportTable"
      show-empty
      stacked="md"
      :items="filterOrdersByKds"
      head-variant="dark"
      :empty-text="'No Records'"
      sort-icon-left
      :empty-filtered-text="'NoRecords'"
      details-td-class="p-0 table-light"
      :fields="fields"
      :current-page="currentPage"
      :busy.sync="progressing"
      @context-changed="getItems"
      @row-clicked="openDetailsByClickOnEachRowTable"
      sort-by="Submitted"
      sort-desc
    >
      <!--            <template #table-busy>-->
      <!--                <div class="text-center text-danger my-2">-->
      <!--                    <b-spinner class="align-middle mx-3"></b-spinner>-->
      <!--                    <strong>Loading...</strong>-->
      <!--                </div>-->
      <!--            </template>-->
      <template v-slot:cell(CustomerName)="row">
        {{ row.item.CustomerName }} 
        <span class="mx-2" v-if="row.item.OrderID == row.item.OriginalOrderID">
          (Party 1)
        </span>
      </template>

      <template v-slot:cell(PaymentStatus)="row">
        {{ row.item.PaymentStatus }}
        <!--                <span v-if="showPartialRefundSymbol(row)">-->
        <!--                        *-->
        <!--                </span>-->
        <p
          v-if="row.item.Refund && (row.item.PaymentStatusID == 1 || row.item.PaymentStatusID == 4)"
          class="text-danger small mb-0"
        >
          Tab Refunded
        </p>
      </template>

      <template v-slot:cell(TabNo)="row">
        <span>{{ row.item.TabNo }}</span>
        <span v-if="row.item.OrderTypeID === 2 && row.item.TableNumber">
          {{ ' - ' + row.item.TableNumber }}
        </span>

        <!--                <span v-if="row.item.OrderTypeID === 2">-->
        <!--                    <span v-if="row.item.TableNumber.trim().length"> - </span>-->
        <!--                    {{row.item.TableNumber}}-->
        <!--                </span>-->
      </template>

      <template v-slot:cell(DUE)="row">
        <div v-if="row.item.OrderTypeID === 1 || row.item.OrderTypeID === 0 || row.item.OrderTypeID === 3">
          <span>{{ row.item.DueTime }}</span>
        </div>
      </template>
      <template v-slot:cell(OrderStatus)="row">
        <span class="font-weight-bold text-left" style="color:#f37021">{{ row.item.OrderStatus }}</span>
      </template>
      <template v-slot:cell(Submitted)="row">
        <span class="text-left">{{ validDate(row.item.OrderDate) }}</span>
      </template>
      <template v-slot:cell(details)="row">
        <b-btn size="sm" style="background: #f37021" class="text-white" @click="openDetailsByBtn(row.item)">
          <font-awesome-icon icon="list" class="align-middle" />
        </b-btn>
      </template>

      <template v-slot:row-details="row">
        <b-container fluid class="p-0">
          <b-row class="mx-0 justify-content-center">
            <b-col sm="12" class="bg-white" v-if="row.item.Delivery_Address !== ''">
              <div class="w-50 m-auto pt-3">
                <p class="mb-0">
                  <span class="font-weight-bold">Delivery Address: </span>
                  <span>
                    {{ row.item.Delivery_Address }}
                  </span>
                  <span class="mx-4" v-if="row.item.Delivery_UnitNo !== ''">
                    {{ 'Apt/St/Unit: ' + row.item.Delivery_UnitNo }}
                  </span>
                </p>
                <p class="mb-0">
                  <span class="font-weight-bold">Note: </span>
                  <span>
                    {{ row.item.Delivery_Instruction }}
                  </span>
                </p>
              </div>
            </b-col>

            <b-col cols="12" lg="8" class="bg-white py-3">
              <div class="d-flex flex-row justify-content-between align-items-center mb-3">
                <span v-if="row.item.ServerName" class="mx-4 text-muted">Server: {{ row.item.ServerName }}</span>
                <div v-if="row.item.PackagingType">
                  <div v-if="row.item.PackagingType === 'EAT IN'">
                    SERVE FOR HERE (EAT IN)
                  </div>
                  <div v-else>
                    SERVE FOR TO GO
                  </div>
                </div>
                <template v-if="selectedOrder.ExemptionNo">
                  <span class="text-danger small">
                    No Split Allowed <br />
                    For Tax Exempt
                  </span>
                </template>
                <template v-else>
                  <div
                    class="d-flex"
                    v-if="row.item.OrderTypeID === 2 && row.item.PaymentStatusID === 1 && row.item.OrderStatusID !== 5"
                  >
                    <undo-split class="mx-2" v-if="row.item.SplitType" :order-id="row.item.OrderID" @refresh="updateReport" />
                    <template
                      v-if="
                        selectedOrder.Total - selectedOrder.Fee == '0' &&
                          getTabItems.length === 1 &&
                          getTabItems.find(i => i.Quantity === 1)
                      "
                    >
                    </template>
                    <template v-else>
                      <split-bill @refresh="updateReport" :order-id="row.item.OrderID" :order="row.item" />
                    </template>
                  </div>
                </template>
              </div>
              <b-row>
                <b-col cols="12" lg="4" class="d-flex d-lg-none flex-row justify-content-center bg-white py-3">
                  <div>
                    <h5 class="font-weight-bold text-center text-dark">Order Status</h5>
                    <b-button-group v-if="row.item.OrderTypeID === 0 || row.item.OrderTypeID === 1 || row.item.OrderTypeID === 3">
                      <b-button disabled :class="row.item.OrderStatus === 'New' ? 'activeBtn' : 'deactiveBtn'">NEW</b-button>
                      <b-button disabled :class="row.item.OrderStatus === 'Confirmed' ? 'activeBtn' : 'deactiveBtn'"
                        >CONFIRMED</b-button
                      >
                      <b-button disabled :class="row.item.OrderStatus === 'Ready' ? 'activeBtn' : 'deactiveBtn'">READY</b-button>
                      <b-button disabled :class="row.item.OrderStatus === 'Served' ? 'activeBtn' : 'deactiveBtn'"
                        >SERVED</b-button
                      >
                    </b-button-group>
                    <b-button-group v-else-if="row.item.OrderTypeID === 2">
                      <b-button disabled :class="row.item.OrderStatus === 'New' ? 'activeBtn' : 'deactiveBtn'">NEW</b-button>
                      <b-button disabled :class="row.item.OrderStatus === 'Ready' ? 'activeBtn' : 'deactiveBtn'">READY</b-button>
                      <b-button disabled :class="row.item.OrderStatus === 'Served' ? 'activeBtn' : 'deactiveBtn'"
                        >SERVED</b-button
                      >
                    </b-button-group>
                    <div class="text-center mt-3">
                      <vue-easy-print tableShow ref="easyPrint">
                        <template slot-scope="func">
                          <div id="printMe" class="font-weight-bold">
                            <h4 style="font-size: 25px" class="font-weight-bold">
                              {{ 'Tab  ' + row.item.TabNo + ' (' + row.item.OrderType + ') ' }}
                            </h4>
                            <p class="text-dark mb-0" style="font-size: 18px">
                              {{ 'Submitted: ' + validDate(row.item.OrderDate) }}
                            </p>
                            <p class="font-weight-bold mb-0" style="font-size: 18px">Name: {{ row.item.CustomerName }}</p>
                            <p class="font-weight-bold" style="font-size: 18px">Due: {{ row.item.DueTime }}</p>
                            <div v-for="item in printFood(getTabItems)" class="item d-flex font-weight-bold flex-row py-2">
                              <div>
                                <p class="mb-0" style="font-size: 18px">
                                  <span>{{ item.Quantity }}x</span>
                                </p>
                              </div>
                              <div class="px-2">
                                <p class="mb-0 d-flex flex-column" style="font-size: 18px">
                                  <span>{{ item.ItemName }}</span>
                                  <span style="font-size:19px" v-if="item.ItemName_SecondLang !== '' && AllowSecondLang">{{
                                    item.ItemName_SecondLang
                                  }}</span>
                                </p>
                                <p class="mb-0" style="font-size: 15px">
                                  <span class="d-flex flex-column">
                                    <span>{{ item.PriceComment }}</span>
                                    <span style="font-size:19px" v-if="item.PriceComment_SecondLang !== '' && AllowSecondLang">{{
                                      item.PriceComment_SecondLang
                                    }}</span>
                                  </span>
                                </p>
                                <p class="mb-0" style="font-size: 15px">{{ item.Modifiers }}</p>
                                <p
                                  v-if="item.Modifiers_SecondLang !== '' && AllowSecondLang"
                                  class="mb-0"
                                  style="font-size: 15px"
                                >
                                  {{ item.Modifiers_SecondLang }}
                                </p>
                                <p class="mb-0" v-if="item.Description.trim().length">
                                  {{ item.Description }}
                                </p>
                              </div>
                            </div>
                            <div v-for="item in printDrinks(getTabItems)" class="item d-flex font-weight-bold flex-row py-2">
                              <div>
                                <p class="mb-0" style="font-size: 18px">
                                  <span>{{ item.Quantity }}x</span>
                                </p>
                              </div>
                              <div class="px-2">
                                <p class="mb-0" style="font-size: 18px">
                                  <span class="d-flex flex-column">
                                    <span
                                      >{{ item.ItemName }}
                                      <span class="mx-4" v-if="item.Alcoholic">
                                        * ALC. VERIFY AGE *
                                      </span>
                                    </span>
                                    <span style="font-size:19px" v-if="item.ItemName_SecondLang !== '' && AllowSecondLang">{{
                                      item.ItemName_SecondLang
                                    }}</span>
                                  </span>
                                </p>
                                <p class="mb-0" style="font-size: 15px">
                                  <span class="d-flex flex-column">
                                    <span>{{ item.PriceComment }}</span>
                                    <span style="font-size:19px" v-if="item.PriceComment_SecondLang !== '' && AllowSecondLang">{{
                                      item.PriceComment_SecondLang
                                    }}</span>
                                  </span>
                                </p>
                                <p class="mb-0" style="font-size: 15px">{{ item.Modifiers }}</p>
                                <p
                                  v-if="item.Modifiers_SecondLang !== '' && AllowSecondLang"
                                  class="mb-0"
                                  style="font-size: 15px"
                                >
                                  {{ item.Modifiers_SecondLang }}
                                </p>
                                <p class="mb-0" v-if="item.Description.trim().length">
                                  {{ item.Description }}
                                </p>
                              </div>
                            </div>
                            <div class="mt-2" style="width: 6cm !important">
                              <p class="mb-0 small d-block font-weight-bold" v-if="row.item.OrderDescription !== ''">
                                Note : {{ row.item.OrderDescription }}
                              </p>
                            </div>
                          </div>
                        </template>
                      </vue-easy-print>
                      <!--                                    <button @click="printMe" class="bg-transparent border-0 text-primary font-weight-bold">-->
                      <!--                                        <span class="font-weight-bold">Print Tab...</span>-->
                      <!--                                    </button>-->
                      <div class="">
                        <keep-alive>
                          <print-recipient
                            :items="getTabItems"
                            :info="row.item"
                            :AllowSecondLang="AllowSecondLang"
                            :HasActiveReceiptPrinter="HasActiveReceiptPrinter"
                            :HasActiveTicketPrinter="HasActiveTicketPrinter"
                            :RestaurantPhoneNumber="RestaurantPhoneNumber"
                            :RestaurantAddress="RestaurantAddress"
                            :RestaurantName="RestaurantName"
                            :RestaurantCity="RestaurantCity"
                            :RestaurantState="RestaurantState"
                            :RestaurantZIP="RestaurantZIP"
                            @callbackResult="callBackPrintServer"
                            :printers="printers"
                            :serverIp="serverIp"
                            @returnPrintes="returnPrintes"
                            :cardInfo="cardInfo"
                            :loadPrint="loadPrint"
                            ref="PrintReceipt"
                          />
                        </keep-alive>

                        <div v-if="errorPrintReciept !== null">
                          <p class="mt-3" :class="errorPrintReciept.hasError ? 'text-danger' : 'text-success'">
                            {{ errorPrintReciept.message }}
                          </p>
                        </div>
                        <div v-if="disconnectIps.length">
                          <b-btn variant="link" @click="showDeactiveIps = !showDeactiveIps">
                            Print Error Details...
                          </b-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-table-simple striped responsive class="m-0 p-0 detailTable">
                <b-thead>
                  <b-td> </b-td>
                  <b-td colspan="4" class="text-center">
                    <span v-if="dineInAndSplitByAmount(row.item)" class="text-danger font-weight-bold">
                      This tab is split by amount.
                    </span>
                  </b-td>
                  <b-td class="font-weight-bold">
                    <!--                                        <span v-if="HasActiveTicketPrinter">-->
                    <!--                                            Ticket Print        -->
                    <!--                                        </span>-->
                  </b-td>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="(item, index) in getTabItems" :key="'details' + index">
                    <b-td>{{ item.Quantity }}x</b-td>
                    <b-td>
                      <!--                                            && !dineInAndSplitByAmount(row.item)-->
                      <span v-if="selectedOrder.OrderStatusID != 5 && !dineInAndSplitByAmount(row.item)">
                        <font-awesome-icon
                          v-if="row.item.PaymentStatusID === 1 || row.item.PaymentStatusID === 3"
                          icon="pencil-alt"
                          class="cursor-pointer"
                          @click="editItem(row.item.OrderTypeID, item.IKey, row.item, item)"
                        />
                      </span>
                    </b-td>
                    <b-td :class="item.DrinkID !== 0 ? 'alcoholicText font-weight-bold' : 'text-dark'">
                      <span class="d-flex flex-column">
                        <span
                          >{{ item.ItemName }}
                          <span class="mx-5" v-if="item.Alcoholic" :class="item.Alcoholic ? 'alcoholicText' : 'text-dark'">
                            * ALC. VERIFY AGE *
                          </span>
                        </span>
                        <span v-if="item.ItemName_SecondLang !== '' && AllowSecondLang">{{ item.ItemName_SecondLang }}</span>
                      </span>

                      <p class="mb-0 text-danger font-weight-bold">
                        <span class="d-flex">
                          <span>{{ item.PriceComment }}</span>
                          <span class="mx-2" v-if="item.PriceComment_SecondLang !== '' && AllowSecondLang">{{
                            item.PriceComment_SecondLang
                          }}</span>
                        </span>
                      </p>
                      <p class="mb-0">
                        <span class="d-flex flex-column">
                          <span class="mb-0 font-weight-bold" style="color: red">{{ item.Modifiers }}</span>
                          <span
                            v-if="item.Modifiers_SecondLang !== '' && AllowSecondLang"
                            class="mb-0 font-weight-bold"
                            style="color: red"
                            >{{ item.Modifiers_SecondLang }}</span
                          >
                          <span class="text-danger font-weight-bold" v-if="item.Description.trim().length">
                            note: {{" "+ item.Description }}</span
                          >
                        </span>
                      </p>
                    </b-td>
                    <b-td :class="item.DrinkID !== 0 ? 'alcoholicText font-weight-bold' : 'text-dark'"
                      >${{ item.Price.toFixed(2) }}
                      <span class="mb-4 d-inline-block" v-if="dineInAndSplitByAmount(row.item)">*</span>
                      <p
                        v-if="dineInAndSplitByAmount(row.item) && index === getTabItems.length - 1"
                        class="font-italic text-dark"
                      >
                        *Pre-split price
                      </p>
                    </b-td>
                    <b-td class="text-center">
                      <b-button-group v-if="row.item.OrderTypeID === 2">
                        <b-button size="sm" disabled :class="item.OrderStatus === 1 ? 'activeBtn' : 'deactiveBtn'">NEW</b-button>
                        <b-button size="sm" disabled :class="item.OrderStatus === 3 ? 'activeBtn' : 'deactiveBtn'"
                          >READY</b-button
                        >
                        <b-button size="sm" disabled :class="item.OrderStatus === 4 ? 'activeBtn' : 'deactiveBtn'"
                          >SERVED</b-button
                        >
                      </b-button-group>
                      <b-button-group
                        v-else-if="row.item.OrderTypeID === 0 || row.item.OrderTypeID === 1 || row.item.OrderTypeID === 3"
                      >
                        <b-button
                          size="sm"
                          disabled
                          :class="item.OrderStatus === 1 || item.OrderStatus === 2 ? 'activeBtn' : 'deactiveBtn'"
                          >NEW</b-button
                        >
                        <b-button size="sm" disabled :class="item.OrderStatus === 3 ? 'activeBtn' : 'deactiveBtn'"
                          >READY</b-button
                        >
                        <b-button size="sm" disabled :class="item.OrderStatus === 4 ? 'activeBtn' : 'deactiveBtn'"
                          >SERVED</b-button
                        >
                      </b-button-group>
                    </b-td>
                    <b-td class="">
                      <div class="d-flex align-items-center">
                        <!--                                                <b-form-checkbox-->
                        <!--                                                        v-if="!item.printed"-->
                        <!--                                                        :id="'checkbox' + index"-->
                        <!--                                                        v-model="item.checked"-->
                        <!--                                                        :name="'checkbox' + index"-->
                        <!--                                                        :value="true"-->
                        <!--                                                        :disabled="item.disabled"-->
                        <!--                                                        :unchecked-value="false"-->
                        <!--                                                >-->
                        <!--                                                </b-form-checkbox>-->
                        <font-awesome-icon
                          v-if="item.printed && item.success"
                          icon="check"
                          class="mx-3 text-success align-middle"
                        />
                        <font-awesome-icon
                          @click="showErrorPrintTicket(item)"
                          v-if="!item.printed && item.failur"
                          icon="info"
                          style="cursor: pointer"
                          class="text-danger mx-3 align-middle"
                        />
                      </div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
              <p class="mb-0 font-weight-bold" style="color:#f37021" v-if="row.item.OrderDescription !== ''">
                Note : {{ row.item.OrderDescription }}
              </p>
            </b-col>

            <b-col cols="12" lg="4" class="d-none d-lg-flex flex-row justify-content-center bg-white py-3">
              <div>
                <h5 class="font-weight-bold text-center text-dark">Order Status</h5>
                <b-button-group v-if="row.item.OrderTypeID === 0 || row.item.OrderTypeID === 1 || row.item.OrderTypeID === 3">
                  <b-button disabled :class="row.item.OrderStatus === 'New' ? 'activeBtn' : 'deactiveBtn'">NEW</b-button>
                  <b-button disabled :class="row.item.OrderStatus === 'Confirmed' ? 'activeBtn' : 'deactiveBtn'"
                    >CONFIRMED</b-button
                  >
                  <b-button disabled :class="row.item.OrderStatus === 'Ready' ? 'activeBtn' : 'deactiveBtn'">READY</b-button>
                  <b-button disabled :class="row.item.OrderStatus === 'Served' ? 'activeBtn' : 'deactiveBtn'">SERVED</b-button>
                </b-button-group>
                <b-button-group v-else-if="row.item.OrderTypeID === 2">
                  <b-button disabled :class="row.item.OrderStatus === 'New' ? 'activeBtn' : 'deactiveBtn'">NEW</b-button>
                  <b-button disabled :class="row.item.OrderStatus === 'Ready' ? 'activeBtn' : 'deactiveBtn'">READY</b-button>
                  <b-button disabled :class="row.item.OrderStatus === 'Served' ? 'activeBtn' : 'deactiveBtn'">SERVED</b-button>
                </b-button-group>
                <div class="text-center mt-3">
                  <vue-easy-print tableShow ref="easyPrint">
                    <template slot-scope="func">
                      <div id="printMe" class="font-weight-bold">
                        <h4 style="font-size: 25px" class="font-weight-bold">
                          {{ 'Tab  ' + row.item.TabNo + ' (' + row.item.OrderType + ') ' }}
                        </h4>
                        <p class="text-dark mb-0" style="font-size: 18px">{{ 'Submitted: ' + validDate(row.item.OrderDate) }}</p>
                        <p class="font-weight-bold mb-0" style="font-size: 18px">Name: {{ row.item.CustomerName }}</p>
                        <p class="font-weight-bold" style="font-size: 18px">Due: {{ row.item.DueTime }}</p>
                        <div v-for="item in printFood(getTabItems)" class="item d-flex font-weight-bold flex-row py-2">
                          <div>
                            <p class="mb-0" style="font-size: 18px">
                              <span>{{ item.Quantity }}x</span>
                            </p>
                          </div>
                          <div class="px-2">
                            <p class="mb-0 d-flex flex-column" style="font-size: 18px">
                              <span>{{ item.ItemName }}</span>
                              <span style="font-size:19px" v-if="item.ItemName_SecondLang !== '' && AllowSecondLang">{{
                                item.ItemName_SecondLang
                              }}</span>
                            </p>
                            <p class="mb-0" style="font-size: 15px">
                              <span class="d-flex flex-column">
                                <span>{{ item.PriceComment }}</span>
                                <span style="font-size:19px" v-if="item.PriceComment_SecondLang !== '' && AllowSecondLang">{{
                                  item.PriceComment_SecondLang
                                }}</span>
                              </span>
                            </p>
                            <p class="mb-0" style="font-size: 15px">{{ item.Modifiers }}</p>
                            <p v-if="item.Modifiers_SecondLang !== '' && AllowSecondLang" class="mb-0" style="font-size: 15px">
                              {{ item.Modifiers_SecondLang }}
                            </p>
                            <p class="mb-0" v-if="item.Description.trim().length">
                              Note: {{""+ item.Description }}
                            </p>
                          </div>
                        </div>
                        <div v-for="item in printDrinks(getTabItems)" class="item d-flex font-weight-bold flex-row py-2">
                          <div>
                            <p class="mb-0" style="font-size: 18px">
                              <span>{{ item.Quantity }}x</span>
                            </p>
                          </div>
                          <div class="px-2">
                            <p class="mb-0" style="font-size: 18px">
                              <span class="d-flex flex-column">
                                <span
                                  >{{ item.ItemName }}
                                  <span class="mx-4" v-if="item.Alcoholic">
                                    * ALC. VERIFY AGE *
                                  </span>
                                </span>
                                <span style="font-size:19px" v-if="item.ItemName_SecondLang !== '' && AllowSecondLang">{{
                                  item.ItemName_SecondLang
                                }}</span>
                              </span>
                            </p>
                            <p class="mb-0" style="font-size: 15px">
                              <span class="d-flex flex-column">
                                <span>{{ item.PriceComment }}</span>
                                <span style="font-size:19px" v-if="item.PriceComment_SecondLang !== '' && AllowSecondLang">{{
                                  item.PriceComment_SecondLang
                                }}</span>
                              </span>
                            </p>
                            <p class="mb-0" style="font-size: 15px">{{ item.Modifiers }}</p>
                            <p v-if="item.Modifiers_SecondLang !== '' && AllowSecondLang" class="mb-0" style="font-size: 15px">
                              {{ item.Modifiers_SecondLang }}
                            </p>
                            <p class="mb-0" v-if="item.Description.trim().length">
                              Note:{{" "+ item.Description }}
                            </p>
                          </div>
                        </div>
                        <div class="mt-2" style="width: 6cm !important">
                          <p class="mb-0 small d-block font-weight-bold" v-if="row.item.OrderDescription !== ''">
                            Note : {{ row.item.OrderDescription }}
                          </p>
                        </div>
                      </div>
                    </template>
                  </vue-easy-print>
                  <!--                                    <button @click="printMe" class="bg-transparent border-0 text-primary font-weight-bold">-->
                  <!--                                        <span class="font-weight-bold">Print Tab...</span>-->
                  <!--                                    </button>-->
                  <div class="">
                    <keep-alive>
                      <print-recipient
                        :items="getTabItems"
                        :info="row.item"
                        :AllowSecondLang="AllowSecondLang"
                        :HasActiveReceiptPrinter="HasActiveReceiptPrinter"
                        :HasActiveTicketPrinter="HasActiveTicketPrinter"
                        :RestaurantPhoneNumber="RestaurantPhoneNumber"
                        :RestaurantAddress="RestaurantAddress"
                        :RestaurantName="RestaurantName"
                        :RestaurantCity="RestaurantCity"
                        :RestaurantState="RestaurantState"
                        :RestaurantZIP="RestaurantZIP"
                        @callbackResult="callBackPrintServer"
                        :printers="printers"
                        :serverIp="serverIp"
                        @returnPrintes="returnPrintes"
                        :cardInfo="cardInfo"
                        :loadPrint="loadPrint"
                        ref="PrintReceipt"
                      />
                    </keep-alive>

                    <div v-if="errorPrintReciept !== null">
                      <p class="mt-3" :class="errorPrintReciept.hasError ? 'text-danger' : 'text-success'">
                        {{ errorPrintReciept.message }}
                      </p>
                    </div>
                    <div v-if="disconnectIps.length">
                      <b-btn variant="link" @click="showDeactiveIps = !showDeactiveIps">
                        Print Error Details...
                      </b-btn>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-table>
    <!--        <p class="mb-0">* Partially refunded</p>-->

    <b-pagination
      v-if="totalPage > 0"
      v-model="currentPage"
      :total-rows="totalPage"
      :per-page="perPage"
      class="my-3"
    ></b-pagination>
    <b-sidebar
      v-model="orderDetailsSide"
      :backdrop-variant="'dark'"
      backdrop
      shadow
      no-header
      no-header-close
      sidebar-class="bg-white"
      id="sidebar-right"
      right
      shadow
    >
      <b-container fluid>
        <b-row>
          <b-col sm="12" class="d-flex flex-column">
            <div class="pt-3">
              <order-information :order="selectedOrder" />

              <div class="my-3" v-if="selectedOrder.OrderStatus !== 'Canceled'">
                <UpdateCredit
                  v-if="
                    selectedOrder.PaymentStatusID === 1 ||
                      (selectedOrder.PaymentStatusID === 3 && $hasPermission([0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]))
                  "
                  :Subtotal="selectedOrder.Subtotal + selectedOrder.Credit"
                  :Credit="Credit"
                  :orderId="selectedOrderID"
                  :order="selectedOrder"
                  @updateCredit="updateCredit"
                  :loadingBtn="loadingBtn"
                />
              </div>
            </div>

            <div
              class="my-3"
              v-if="
                selectedOrder.PaymentStatusID === 1 &&
                  selectedOrder.OrderStatus !== 'Canceled' &&
                  selectedOrder.Total - selectedOrder.Fee &&
                  $hasPermission([0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12])
              "
            >
              <payment-operation
                :order="selectedOrder"
                @updateReport="updateReport"
                :Total="selectedOrder.Total - selectedOrder.Fee"
                :tab-no="selectedOrder.TabNo"
                :table-no="selectedOrder.TableNumber"
                @openCashBox="openCashBox"
                @getReceipt="getReceipt"
                :HasActiveReceiptPrinter="HasActiveReceiptPrinter"
                :HasActiveTicketPrinter="HasActiveTicketPrinter"
              />
            </div>

            <div class="my-3" v-if="selectedOrder.Total - selectedOrder.Fee == '0' && selectedOrder.PaymentStatusID === 1">
              <close-tab
                :order="selectedOrder"
                :Total="selectedOrder.Total - selectedOrder.Fee"
                :tab-no="selectedOrder.TabNo"
                :table-no="selectedOrder.TableNumber"
                :HasActiveReceiptPrinter="HasActiveReceiptPrinter"
                :HasActiveTicketPrinter="HasActiveTicketPrinter"
                @updateReport="updateReport"
                @getReceipt="getReceipt"
                @openCashBox="openCashBox"
              />
            </div>

            <div class="my-3" v-if="selectedOrder.OrderStatus !== 'Canceled'">
              <cancel-tab
                v-if="
                  selectedOrder.PaymentStatusID === 1 ||
                    (selectedOrder.PaymentStatusID === 3 && $hasPermission([0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]))
                "
                :cancelData="cancelReason"
                @cancelOrder="cancelOrder"
                :progressing="loadingBtn"
                :order="selectedOrder"
              />
            </div>

            <div class="my-3 sendText">
              <send-text-order
                v-if="selectedOrder.OrderStatus !== 'Canceled'"
                :disabled="!showTextMessage"
                :messages="messages"
                :order-id="selectedOrderID"
                :customer-phone="selectedOrder.Phone"
                button-label="Send Text To Customer"
              />
            </div>

            <div v-if="selectedOrder.OrderStatusID !== 5 && selectedOrder.PaymentStatusID === 1">
              <tax-exemption :order="selectedOrder" @refresh="updateMasterList" />
            </div>

            <div v-if="selectedOrder.PaymentStatusID === 2 || selectedOrder.PaymentStatusID === 4">
              <send-email :value="selectedOrder" />
            </div>

            <div
              class="my-3"
              v-if="selectedOrder.OrderStatus !== 'Canceled' && $hasPermission([0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12])"
            >
              <refund-tab
                v-if="
                  (selectedOrder.PaymentStatusID === 2 && selectedOrder.Refund < selectedOrder.Total) ||
                    (selectedOrder.PaymentStatusID === 4 && selectedOrder.Refund < selectedOrder.Total - selectedOrder.Fee)
                "
                :order-id="selectedOrderID"
                :order="selectedOrder"
                :credit="selectedOrder.PaymentStatusID === 4 ? selectedOrder.Total - selectedOrder.Fee : selectedOrder.Total"
                :payment-status="selectedOrder.PaymentStatusID"
                @refresh="updateMasterList"
              />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-sidebar>

    <!-- Info modal -->
    <b-modal body-class="p-0" v-model="editModal" size="lg" hide-header hide-footer>
      <edit-item
        :order="selectedOrder"
        :OrderType="OrderTypeID"
        :selectedOrderID="selectedOrderID"
        :OrderDetailID="orderDetailID"
        @deleteItem="deleteItem"
        @editItemFinaly="editItemFinaly"
        @cancelEditItem="cancelEditItem"
        :loadingBtn="loadingBtn"
        :itemLength="itemLength"
        :disabled-field="orderStatusField.orderType === 2 && orderStatusField.itemStatus !== 1"
      />
    </b-modal>
    <b-modal size="lg" content-class="p-0" body-class="p-0" centered hide-header hide-footer v-model="showDeactiveIps">
      <b-card no-body class="m-0">
        <b-card-header>
          <span>Print Error Details</span>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col class="mb-0 mt-2" cols="12" v-for="item in disconnectIps">
              <div class="">
                <p class="my-1">Printstation Name : {{ item.PrinterName + ' ' + '(' + item.IPAddress + ')' }}</p>
                <p class="my-1 text-danger">Error : {{ item.printError }}</p>
                <p class="my-1"></p>
              </div>
              <hr class="my-0" />
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-modal>
    <b-modal size="lg" content-class="p-0" body-class="p-0" centered hide-header hide-footer v-model="ticketError">
      <b-card no-body class="m-0">
        <b-card-header>
          <span>Print Error Details</span>
        </b-card-header>
        <b-card-body class="py-2">
          <b-row>
            <b-col class="mb-0 mt-2" cols="12">
              <div class="">
                <p class="my-1">
                  Printstation Name : {{ printTicketErrorObject.name + ' ' + '(' + printTicketErrorObject.ip + ')' }}
                </p>
                <p class="my-1 text-danger">Error : {{ printTicketErrorObject.error }}</p>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-modal>
  </b-container>
</template>

<script>
import moment from 'moment'
import UpdateCredit from './UpdateCredit'
import cancelOrder from './cancelOrder'
import editItem from './editItem'
import {printTab} from '../../lib/print'
import vueEasyPrint from 'vue-easy-print'
import PrintRecipient from './printRecipient'
import PrintTicket from './printTicket'
import PaymentOperation from './paymentOperation'
import JSPM from 'jsprintmanager'
import UpdateTableNumber from '../shared/updateTableNumber'
import SendEmail from '../shared/SendEmail'
import SendTextOrder from '../shared/sendTextOrder'
import EditServer from '../shared/editServer'
import CloseTab from '../shared/CloseTab'
import UndoSplit from '../shared/undoSplit'
import SplitBill from '../shared/splitBill'
import CancelTab from '../shared/cancelTab'
import RefundTab from '../shared/refundTab'
import TaxExemption from '../shared/taxExemption'
import OrderInformation from './components/orderInformation'

export default {
  name: 'todayOrders',
  components: {
    OrderInformation,
    TaxExemption,
    RefundTab,
    CancelTab,
    SplitBill,
    UndoSplit,
    CloseTab,
    SendEmail,
    SendTextOrder,
    EditServer,
    PaymentOperation,
    PrintRecipient,
    UpdateCredit,
    cancelOrder,
    editItem,
    vueEasyPrint,
    PrintTicket,
    UpdateTableNumber
  },
  data() {
    return {
      reasonItems: [
        {text: 'Promotions', value: 'Promotions'},
        {text: 'Guest Relations', value: 'Guest Relations'},
        {text: 'Staff Meals', value: 'Staff Meals'},
        {text: 'Owner Meals', value: 'Owner Meals'},
        {text: 'Cash (No-Penny) Rounding', value: 'Cash (No-Penny) Rounding'},
        {text: 'Other', value: 'Other'}
      ],
      RefundReason: null,
      progressing: false,
      loadPrint: false,
      ticketError: false,
      printTicketErrorObject: {
        name: null,
        ip: null,
        error: null
      },
      showDeactiveIps: false,
      serverIp: null,
      orderDetailID: '',
      OrderTypeID: '',
      Search: '',
      itemLength: [],
      editModal: false,
      cancelModal: false,
      cancelReason: [],
      loadingBtn: false,
      AllowSecondLang: false,
      items: [],
      totalPage: 0,
      cardInfo: {
        paid: false,
        CardBrand: null,
        Last4: null,
        NameOnCard: null,
        Wallet: null,
        PaymentDate: null
      },
      fields: [
        {key: 'TabNo', label: 'Tab - Table No', sortable: false, sortDirection: 'desc', class: ''},
        {key: 'OrderType', label: 'Type', sortable: false, class: ''},
        {key: 'OrderStatus', label: 'Status', sortable: false, class: ''},
        {key: 'PaymentStatus', label: 'Pay', sortable: false},
        {key: 'CustomerName', label: 'Name', sortable: false, class: ''},
        {key: 'Submitted', label: 'Submitted', sortable: true, class: ''},
        {key: 'DUE', label: 'Due', sortable: true},
        {
          key: 'details',
          label: '...',
          sortable: false,
          class: this.$hasPermission([0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]) ? 'text-center' : 'd-none'
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      detailsObject: {},
      selectedOrderID: null,
      orderDetailsSide: false,
      showCrediteComponent: false,
      selectedOrder: {
        Total: null,
        Fee: null,
        Tip_Percentage: null,
        Tax: null,
        Subtotal: null,
        Credit: null,
        Refund: 0,
        PaymentStatus: null,
        Tip: null,
        Delivery_Fee: null,
        Tax_adj: null,
        Subtotal_adj: null,
        SplitType: '',
        OrderTypeID: null,
        TableNumber: null,
        OrderStatusID: null,
        ExemptionNo: null,
        Phone: ''
      },
      messages: [],
      refundModal: false,
      refundType: 'FullRefund',
      selected: '',
      soundurl: 'http://soundbible.com/mp3/analog-watch-alarm_daniel-simion.mp3',
      enableCredit: false,
      Credit: null,
      refundValue: null,
      showResetBtn: false,
      kdsList: [],
      selectedKds: null,
      HasActiveReceiptPrinter: false,
      HasActiveTicketPrinter: false,
      errorPrintReciept: null,
      printers: [],
      disconnectIps: [],
      showDeactiveIps: false,
      RestaurantAddress: null,
      RestaurantName: null,
      RestaurantPhoneNumber: null,
      RestaurantCity: null,
      RestaurantState: null,
      RestaurantZIP: null,
      servers: [],
      ServerName: '-1',
      Filter_KDS: -1,
      orderStatusField: {
        itemStatus: '',
        orderType: ''
      }
    }
  },
  metaInfo() {
    return {
      title: 'Order History'
    }
  },
  watch: {
    '$store.state.selectedRestaurantId': {
      // get restaurant orders

      handler: function(newVal) {
        if (newVal) {
          let object = {
            RestaurantID: newVal,
            // UserID: localStorage.getItem('userID')
          }
          Promise.all([
            this.GetRestaurantKDSs(object),
            this.getPrinters(object),
            this.GetServerPrinterIP(object),
            this.GetRestaurantOrderServer(object)
          ]).then(() => {
            this.getItems(this.$refs.table.context)
            // let data = {
            //     RestaurantID: newVal,
            //     UserID: localStorage.getItem('userID'),
            //     IsLive: 0,
            //     Filter_OrderStatus: -1,
            //     Search: this.Search.trim(),
            //     Sort: 'OrderDate'
            // }
            // this.GetRestaurantOrders(data)
          })
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.GetOrderCancelReason()
    this.GetSMSMessages()
  },
  computed: {
    showTextMessage() {
      return this.selectedOrder.Phone.length < 15 && this.selectedOrder.Phone.length > 0
    },
    //show tab items by kdsid
    getTabItems() {
      this.detailsObject.RestaurantOrderDetails.forEach(item => {
        // this.$set(item, 'checked', false)
        this.$set(item, 'printed', false)
      })
      // if (this.selectedKds !== null) {
      //     return this.detailsObject.RestaurantOrderDetails.filter(item => item.KDSid === this.selectedKds)
      // } else {
      //     return this.detailsObject.RestaurantOrderDetails
      // }
      return this.detailsObject.RestaurantOrderDetails
    },
    activePrintTicketBtn() {
      return this.detailsObject.RestaurantOrderDetails.filter(i => i.checked)
    },
    filterOrdersByKds() {
      if (this.selectedKds !== null) {
        this.currentPage = 1
        //KDSs
        return this.items.filter(item => item.KDSs.match(this.selectedKds))
      } else {
        return this.items
      }
    }
  },
  methods: {
    GetRestaurantOrderServer(filter) {
      filter.ListName = 'Today'
      filter.IsLive = 0
      filter.MenuTypeID = 0
      return this.$api.getRestaurant
        .GetRestaurantOrderServer(filter)
        .then(res => {
          if (res.success) {
            this.ServerName = '-1'
            const servers = res.listOfRestaurantOrderServers.map(item => {
              return {
                text: item.ServerName,
                value: item.ServerName
              }
            })
            this.servers = [{text: 'All', value: '-1'}, {text: 'BLANK', value: 'BLANK'}, ...servers]
          }
        })
        .catch(() => {})
    },
    changeServer() {
      this.getItems(this.$refs.table.context)
    },
    changeKds() {
      this.getItems(this.$refs.table.context)
    },
    showPartialRefundSymbol(row) {
      if (row.item.Refund) {
        return row.item.Refund < row.item.Total ? true : false
      }
      return false
    },
    dineInAndSplitByAmount(order) {
      return order.OrderTypeID === 2 && order.SplitType === 'Amount'
    },
    getItems(ctx) {
      this.loadingBtn = true
      this.progressing = true
      return this.$api.getRestaurant
        .GetRestaurantOrders(this.filter(ctx), true)
        .then(res => {
          this.loadingBtn = false
          this.progressing = false
          if (res.success) {
            this.items = res.results.RestaurantOrders
            if (this.items.length) {
              this.totalPage = this.items[0].Total_Record
            } else {
              this.totalPage = 0
            }
            this.RestaurantAddress = res.results.RestaurantAddress
            this.RestaurantName = res.results.RestaurantName
            this.RestaurantPhoneNumber = res.results.RestaurantPhoneNumber
            this.RestaurantCity = res.results.RestaurantCity
            this.RestaurantState = res.results.RestaurantState
            this.RestaurantZIP = res.results.RestaurantZIP
            this.AllowSecondLang = res.results.AllowSecondLang
            this.items.forEach(item => {
              this.$set(item, '_showDetails', false)
            })
            this.totalRows = this.items.length
            if (this.Search !== '') {
              this.showResetBtn = true
            }
            return res
          }
        })
        .catch(() => {})
    },
    filter(ctx, isCount) {
      const filter = {}
      filter.RestaurantID = this.$store.state.selectedRestaurantId
      filter.UserID = localStorage.getItem('userID')
      filter.IsLive = 0
      filter.Filter_OrderStatus = -1
      filter.Filter_ServerName = this.ServerName
      filter.Filter_GeneralOrderStatus = ''
      filter.Filter_KDS = this.Filter_KDS
      filter.Search = this.Search.trim()
      filter.BlockSize = 10
      filter.startIndex = this.currentPage
      if (ctx.sortBy) {
        const sortType = ctx.sortDesc ? 'DESC' : 'ASC'
        filter.Sort = ctx.sortBy + ' ' + sortType
      } else {
        filter.Sort = ''
      }
      return filter
    },

    callbackTicketPrint(data) {
      console.log(data)
    },
    showErrorPrintTicket(print) {
      this.printTicketErrorObject = {
        name: print.PrinterName,
        ip: print.PrinterIP,
        error: print.printError
      }
      this.ticketError = true
    },
    searchInReport() {
      //reset pagination for update b-table

      // this.loadingBtn = true
      // let object = {
      //     RestaurantID: this.$store.state.selectedRestaurantId,
      //     UserID: localStorage.getItem('userID'),
      //     IsLive: 0,
      //     Filter_OrderStatus: -1,
      //     Search: this.Search.trim(),
      //     Sort: 'OrderDate'
      // }
      // this.GetRestaurantOrders(object).then(() => {
      //     this.loadingBtn = false
      // })
      this.currentPage = 1
      this.getItems(this.$refs.table.context)
    },
    resetSearch() {
      //reset pagination for update b-table
      this.currentPage = 1

      this.Search = ''
      this.getItems(this.$refs.table.context).then(() => {
        this.showResetBtn = false
      })
      // let object = {
      //     RestaurantID: this.$store.state.selectedRestaurantId,
      //     UserID: localStorage.getItem('userID'),
      //     IsLive: 0,
      //     Filter_OrderStatus: -1,
      //     Search: '',
      //     Sort: 'OrderDate'
      // }
      // this.GetRestaurantOrders(object).then(() => {
      //     this.loadingBtn = false
      //     this.showResetBtn = false
      // })
    },
    printDrinks(items) {
      return items.filter(i => i.DrinkID !== 0)
    },
    printFood(items) {
      return items.filter(i => i.FoodID !== 0)
    },
    GetOrderCancelReason() {
      //get orderCancel reason items

      return this.$api.getRestaurant.GetOrderCancelReason().then(res => {
        if (res.success) {
          this.cancelReason = res.results.CancelReason
        } else {
          this.$showError(res.message)
        }
      })
    },
    GetSMSMessages() {
      //get sms messages
      return this.$api.getRestaurant.GetSMSMessages().then(res => {
        if (res.success) {
          this.messages = res.results.CancelReason
        } else {
          this.$showError(res.message)
        }
      })
    },
    validDate(date) {
      moment.locale('en-ca')
      return moment(date).format('D MMM YY - hh:mm A')
    },
    validDueDate(date) {
      moment.locale('en-ca')
      const constantDate = '1/1/1900'
      const vaiableDate = moment(date).format('D/M/YYYY')
      if (moment(constantDate).isSame(vaiableDate)) {
        return moment(date).format('hh:mm A')
      } else {
        return moment(date).format('D MMM YY - hh:mm A')
      }
      // return moment(date).format()
    },
    GetRestaurantOrders(object) {
      return this.$api.getRestaurant.GetRestaurantOrders(object).then(res => {
        if (res.success) {
          this.items = res.results.RestaurantOrders
          this.RestaurantAddress = res.results.RestaurantAddress
          this.RestaurantName = res.results.RestaurantName
          this.RestaurantPhoneNumber = res.results.RestaurantPhoneNumber
          this.RestaurantCity = res.results.RestaurantCity
          this.RestaurantState = res.results.RestaurantState
          this.RestaurantZIP = res.results.RestaurantZIP
          this.AllowSecondLang = res.results.AllowSecondLang
          this.items.forEach(item => {
            this.$set(item, '_showDetails', false)
          })
          this.totalRows = this.items.length
          if (this.Search !== '') {
            this.showResetBtn = true
          }
        }
      })
    },
    openDetailsByClickOnEachRowTable(row) {
      //show details of each row
      //There are two ways to display the details of each order
      //By clicking the button and clicking on the row
      this.showDetails(row, 'byRow')
    },
    openDetailsByBtn(selectedOrder) {
      this.orderDetailsSide = true
      this.selectedOrder = selectedOrder
      this.selectedOrderID = selectedOrder.OrderID
      this.TabNo = selectedOrder.TabNo
      //show details of each row
      //There are two ways to display the details of each order
      //By clicking the button and clicking on the row
      this.showDetails(selectedOrder, 'byBtn')
    },
    showDetails(row, type) {
      let object = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        OrderID: row.OrderID
      }
      this.selectedOrderID = row.OrderID

      // selectedOrder

      this.$api.getRestaurant.GetRestaurantOrderDetail(object).then(res => {
        if (res.success) {
          this.selectedOrder = row
          this.HasActiveReceiptPrinter = res.results.HasActiveReceiptPrinter
          this.HasActiveTicketPrinter = res.results.HasActiveTicketPrinter
          this.errorPrintReciept = null
          this.disconnectIps = []
          this.items.forEach(i => {
            if (i.OrderID === row.OrderID) {
              i._showDetails = type === 'byBtn' ? true : !i._showDetails
            } else {
              i._showDetails = false
            }
          })
          this.detailsObject = res.results
          this.itemLength = res.results.RestaurantOrderDetails
          this.detailsObject.RestaurantOrderDetails.forEach(item => {
            if (row.OrderTypeID === 2) {
              this.$set(item, 'checked', false)
            } else {
              this.$set(item, 'checked', true)
            }
            if (item.PrinterIP === '' || item.PrinterIP === null) {
              this.$set(item, 'disabled', true)
              this.$set(item, 'checked', false)
            } else {
              this.$set(item, 'disabled', false)
            }
            this.$set(item, 'printed', false)
          })
          if (row.PaymentStatusID === 2) {
            let cardData = {
              OrderID: row.OrderID,
              RestaurantID: this.$store.state.selectedRestaurantId,
              // UserID: localStorage.getItem('userID')
            }
            this.GetOrderCartInfo(cardData)
          } else {
            this.cardInfo = {
              paid: false,
              CardBrand: null,
              Last4: null,
              NameOnCard: null,
              Wallet: null,
              PaymentDate: null
            }
          }
        }
      })
    },
    GetOrderCartInfo(object) {
      this.$api.getRestaurant.GetOrderCartInfo(object).then(res => {
        if (res.success) {
          this.cardInfo = res.cardInfo
          this.cardInfo.paid = true
        } else {
          this.cardInfo = {
            paid: false,
            CardBrand: null,
            Last4: null,
            NameOnCard: null,
            Wallet: null,
            PaymentDate: null
          }
        }
      })
    },
    updateCredit() {
      this.updateMasterList()
    },
    updateReport() {
      this.orderDetailsSide = false
      this.updateMasterList()
    },
    openCashBox() {
      this.updateMasterList(false)
      this.$refs.PrintReceipt.openCashBox()
    },
    getReceipt() {
      this.$refs.PrintReceipt.getReceiptWithOutPay()
      this.orderDetailsSide = false
    },
    updateMasterList() {
      this.getItems(this.$refs.table.context).then(res => {
        this.items = res.results.RestaurantOrders
        this.AllowSecondLang = res.results.AllowSecondLang
        this.items.forEach(item => {
          this.$set(item, '_showDetails', false)
          if (this.selectedRow === item.OrderID) {
            item._showDetails = true
          }
        })
        this.totalRows = this.items.length
        let findSelectedOrderID = this.items.find(i => i.OrderID === this.selectedOrderID)
        if (findSelectedOrderID) {
          this.selectedOrder = findSelectedOrderID
        }
      })
      // let model = {
      //     RestaurantID: this.$store.state.selectedRestaurantId,
      //     UserID: localStorage.getItem('userID'),
      //     IsLive: 0,
      //     Filter_OrderStatus: -1,
      //     Search: this.Search.trim(),
      //     Sort: 'OrderDate'
      // }
      // this.$api.getRestaurant.GetRestaurantOrders(model, true).then(res => {
      //     if (res.success) {
      //         this.items = res.results.RestaurantOrders
      //         this.AllowSecondLang = res.results.AllowSecondLang
      //         this.items.forEach(item => {
      //             this.$set(item, '_showDetails', false)
      //             if (this.selectedRow === item.OrderID) {
      //                 item._showDetails = true
      //             }
      //         })
      //         this.totalRows = this.items.length
      //         let findSelectedOrderID = this.items.find(i => i.OrderID === this.selectedOrderID)
      //         if (findSelectedOrderID) {
      //             this.selectedOrder = findSelectedOrderID
      //         }
      //     }
      // })
    },
    showItemByClinetTypeID(permissions) {
      //permission component
      //Using this function, we hide some elements from the kds user
      let allowed = false
      let getCurrentUserClient = localStorage.getItem('ClientTypeID')
      let find = permissions.filter(item => item === +getCurrentUserClient)
      if (find.length) {
        allowed = true
      } else {
        allowed = false
      }
      return allowed
    },
    closeCancel() {
      this.cancelModal = false
    },
    cancelOrder(CancelReason) {
      //cancel selected order

      let object = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        OrderID: this.selectedOrderID,
        OrderStatusID: 5,
        CancelReason
      }
      this.loadingBtn = true
      this.$api.getRestaurant
        .UpdateOrderStatus(object)
        .then(res => {
          if (res.success) {
            this.loadingBtn = false
            this.cancelModal = false
            this.orderDetailsSide = false
            this.updateMasterList()
          } else {
            this.$showError(res.message)
            this.loadingBtn = false
          }
        })
        .catch(() => {
          this.loadingBtn = false
        })
    },
    editItem(OrderTypeID, IKey, order, item) {
      this.orderStatusField = {
        itemStatus: item.OrderStatus,
        orderType: order.OrderTypeID
      }
      //show edit item pop up
      this.OrderType = OrderTypeID
      this.orderDetailID = IKey
      this.editModal = true
    },
    deleteItem(OrderDetailID) {
      //Delete items in an order

      let object = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        IKey: OrderDetailID
      }
      this.loadingBtn = true
      this.$api.getRestaurant
        .UpdateDelOrderItem(object)
        .then(res => {
          if (res.success) {
            this.editModal = false
            this.loadingBtn = false
            let object = {
              RestaurantID: this.$store.state.selectedRestaurantId,
              // UserID: localStorage.getItem('userID'),
              OrderID: this.selectedOrderID
            }
            this.$api.getRestaurant.GetRestaurantOrderDetail(object).then(res => {
              if (res.success) {
                this.items.forEach(i => {
                  if (i.OrderID === this.selectedOrderID) {
                    i._showDetails = true
                  } else {
                    i._showDetails = false
                  }
                })
                this.detailsObject = res.results
              }
            })
          } else {
            this.loadingBtn = false
            this.$showError(res.message)
          }
        })
        .catch(() => {
          this.loadingBtn = false
        })
    },
    editItemFinaly(data) {
      //edit item

      this.loadingBtn = true
      this.$api.getRestaurant
        .UpdateOrderAddItem(data)
        .then(res => {
          if (res.success) {
            this.loadingBtn = false
            this.editModal = false
            let object = {
              RestaurantID: this.$store.state.selectedRestaurantId,
              // UserID: localStorage.getItem('userID'),
              OrderID: this.selectedOrderID
            }
            this.$api.getRestaurant.GetRestaurantOrderDetail(object).then(res => {
              if (res.success) {
                this.items.forEach(i => {
                  if (i.OrderID === this.selectedOrderID) {
                    i._showDetails = true
                  } else {
                    i._showDetails = false
                  }
                })
                this.detailsObject = res.results
              }
            })
          } else {
            this.$showError(res.message)
            this.loadingBtn = false
          }
        })
        .catch(() => {
          this.loadingBtn = false
        })
    },
    cancelEditItem(data) {
      this.editModal = data
    },
    GetRestaurantKDSs(object) {
      //get list of kds
      // when user role is KDS this api was called
      if (this.showItemByClinetTypeID([0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 13])) {
        return this.$api.getRestaurant.GetRestaurantKDSs(object).then(res => {
          if (res.success) {
            res.results.RestaurantKDS.forEach(item => {
              item.value = item.KDSID
              item.text = item.KDS
            })
            const list = res.results.RestaurantKDS
            if (list.length === 1) {
              this.Filter_KDS = res.results.RestaurantKDS[0].KDSID
              this.kdsList = res.results.RestaurantKDS
            } else {
              this.Filter_KDS = -1
              this.kdsList = [{value: -1, text: 'All'}].concat(res.results.RestaurantKDS)
            }
            return res
          }
        })
      }
    },
    getPrinters(object) {
      this.$api.getRestaurant.GetRestaurantPrinters(object).then(res => {
        if (res.success) {
          this.printers = res.results.RestaurantPrinter.filter(i => i.PrintTaskID === 2)
          this.printers.forEach(item => {
            this.$set(item, 'deactive', false)
          })
        }
      })
    },
    printMe() {
      // printTab('#printMe')
      setTimeout(() => {
        this.$refs.easyPrint.print()
      }, 1000)
    },
    callBackPrintServer(data) {
      this.errorPrintReciept = data
      // if (data.printTab) {
      //     this.printMe()
      // }
    },
    returnPrintes(data) {
      this.disconnectIps = data.filter(i => i.deactive)
    },
    GetServerPrinterIP(object) {
      this.$api.getRestaurant.GetServerPrinterIP(object).then(res => {
        if (res.success) {
          this.serverIp = res.results.serverPrinterIp
          this.onInit(this.serverIp)
        }
      })
    },
    onInit(serverIp) {
      if (serverIp) {
        var _this = this
        JSPM.JSPrintManager.license_url = _this.$config.printJspmLisence
        JSPM.JSPrintManager.auto_reconnect = false
        JSPM.JSPrintManager.start(true, serverIp, 23443)
        JSPM.JSPrintManager.WS.onStatusChanged = function() {
          _this.loadPrint = true
        }
      }
    }
  }
}
</script>

<style scoped>
.sendText .btn.disabled,
.sendText .btn:disabled {
  color: #90a4ae !important;
  background: #eceff1 !important;
  border: 1px solid #eceff1 !important;
}
.activeBtn {
  background: #f5c31d !important;
  border-color: #c8ced3 !important;
  font-weight: bold;
  color: #455a64 !important;
}
.deactiveBtn {
  background: #fff !important;
  border-color: #c8ced3 !important;
  color: #c8ced3 !important;
  font-weight: bold;
}
.alcoholicText {
  color: #3d5afe;
}
#printMe {
  display: none;
}
/*@media print {*/

/*    @page {*/
/*        size:80mm !important;*/
/*        margin-top: 0.4cm !important;*/
/*        margin-left: 0.4cm !important;*/
/*        margin-right: 0.4cm !important;*/
/*        margin-bottom: 0.8cm !important;*/

/*    }*/

/*    .break{*/
/*        page-break-after: always;*/
/*    }*/

/*    #printMe{*/
/*        display: block;*/
/*    }*/
/*}*/

.item {
  border-width: 0.01em !important;
  border-bottom: 0.01em solid #707070;
  padding: 3px 3px;
}
.unAvailableDisplaystation {
  font-style: italic;
  opacity: 0.5;
}
</style>
